import { StoryData } from '@cinch-nx/data-storyblok'
import { ReturnsStory } from '../storyblok'

export const returnsFallbackStory: StoryData<ReturnsStory> = {
  name: 'returns',
  created_at: '2026-04-22T14:09:08.823Z',
  published_at: '2026-05-07T14:45:24.662Z',
  id: 168_662_420_822_562,
  uuid: 'bcf30de3-01e3-44af-bf0e-9e5b1bdfa407',
  content: {
    SEO: [],
    _uid: 'e11cd7e3-867b-4d31-b03d-c28f439c791b',
    body: [
      {
        _uid: '722bcb3c-5d1b-4d42-bf4a-517b43774766',
        text: {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: { level: 2, textAlign: 'left' },
              content: [
                {
                  text: 'About our 14-day money back guarantee',
                  type: 'text',
                  marks: [{ type: 'bold' }],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                {
                  text: 'You have 14 days to make sure you love your car or get your money back. If you need to return it, we’ll pick it up for free. No hassle.',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                {
                  text: 'Below is a summary of our guarantee, if you need more details take a look at ',
                  type: 'text',
                },
                {
                  text: 'section 12 of our T\u0026Cs',
                  type: 'text',
                  marks: [
                    {
                      type: 'link',
                      attrs: {
                        href: 'https://www.cinch.co.uk/terms-and-conditions#section-12',
                        uuid: null,
                        anchor: null,
                        target: null,
                        linktype: 'url',
                      },
                    },
                    { type: 'underline' },
                  ],
                },
                { text: '.', type: 'text' },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                {
                  text: 'You can return the car to us within 14 days from the day after the delivery date, we won’t ask for a reason. Please note, you mustn’t use the car after telling us you’re cancelling the agreement and the car needs to be kept in good condition.',
                  type: 'text',
                },
              ],
            },
          ],
        },
        component: 'RichText',
        _editable:
          '\u003C!--#storyblok#{"name": "RichText", "space": "143588", "uid": "722bcb3c-5d1b-4d42-bf4a-517b43774766", "id": "175748037529274"}--\u003E',
      },
      {
        _uid: '515f53df-caca-403a-a242-dba86bb795be',
        text: {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: { level: 2, textAlign: 'left' },
              content: [
                {
                  text: 'Conditions to using the guarantee',
                  type: 'text',
                  marks: [{ type: 'bold' }],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                { text: 'If you ', type: 'text' },
                {
                  text: 'paid for the car in full',
                  type: 'text',
                  marks: [{ type: 'bold' }],
                },
                {
                  text: ', please make a note of the following:',
                  type: 'text',
                },
              ],
            },
            {
              type: 'bullet_list',
              content: [
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'If you paid by Visa, Mastercard debit or credit card, we’ll repay the purchase price back on to that card including the £99 admin fee',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'You mustn’t drive the car more than 250 miles from when it was delivered',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'The car needs to be in the same tip-top condition as when it was delivered',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'You’ll need to return the car’s V5 log book to us by recorded delivery (out of your own pocket, sorry)',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                { text: 'If you ', type: 'text' },
                {
                  text: 'paid for the car using finance',
                  type: 'text',
                  marks: [{ type: 'bold' }],
                },
                {
                  text: ', please make a note of the following:',
                  type: 'text',
                },
              ],
            },
            {
              type: 'bullet_list',
              content: [
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'You will get a refund of the £99 admin fee you paid at checkout',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'You mustn’t drive the car more than 250 miles from when it was delivered',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'You mustn’t have made any alterations or modifications to the car whatsoever',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'The car needs to be in the same tip-top condition as when it was delivered (except for fair wear and tear)',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'The car mustn’t have any charges or claims from any third party against it (including a finance provider)',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'You’ll need to return the car’s V5 log book to us by recorded delivery (out of your own pocket, sorry)',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        component: 'RichText',
        _editable:
          '\u003C!--#storyblok#{"name": "RichText", "space": "143588", "uid": "515f53df-caca-403a-a242-dba86bb795be", "id": "175748037529274"}--\u003E',
      },
      {
        _uid: '1e2f451a-4990-4d68-84fc-5a91b192334f',
        text: {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: { level: 2, textAlign: 'left' },
              content: [
                {
                  text: 'Last but not least, follow these 3 simple steps',
                  type: 'text',
                  marks: [{ type: 'bold' }],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                {
                  text: '1. Contact our Customer Experience team – you can either:',
                  type: 'text',
                },
              ],
            },
            {
              type: 'bullet_list',
              content: [
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'Call ',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                        {
                          text: '03330 154101',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'tel:03330154101',
                                uuid: null,
                                anchor: null,
                                target: null,
                                linktype: 'url',
                              },
                            },
                            { type: 'textStyle', attrs: { color: '' } },
                            { type: 'underline' },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'list_item',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: { textAlign: null },
                      content: [
                        {
                          text: 'Email ',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                        {
                          text: 'hello@cinch.co.uk',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'mailto:hello@cinch.co.uk',
                                uuid: null,
                                anchor: null,
                                target: null,
                                linktype: 'url',
                              },
                            },
                            { type: 'textStyle', attrs: { color: '' } },
                            { type: 'underline' },
                          ],
                        },
                        {
                          text: ' (you can use this ',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                        {
                          text: 'cancellation form',
                          type: 'text',
                          marks: [
                            {
                              type: 'link',
                              attrs: {
                                href: 'https://www.cinch.co.uk/terms-and-conditions#cancellation-form',
                                uuid: null,
                                anchor: null,
                                target: null,
                                linktype: 'url',
                              },
                            },
                            { type: 'textStyle', attrs: { color: '' } },
                            { type: 'underline' },
                          ],
                        },
                        {
                          text: ' if you like). We’ll acknowledge receipt by email and call you within 3 days to arrange the car’s collection. To meet the guarantee deadline, you need to tell us you’re exercising the right to cancel by 8pm on the day the guarantee period ends',
                          type: 'text',
                          marks: [{ type: 'textStyle', attrs: { color: '' } }],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                {
                  text: '2. We’ll arrange to pick up your car at a 2-hour slot of your choosing (after 72 hours of your request)',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [{ text: '3. Er… that’s it! Simple as.', type: 'text' }],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                {
                  text: 'See our FAQs',
                  type: 'text',
                  marks: [
                    {
                      type: 'link',
                      attrs: {
                        href: 'https://www.cinch.co.uk/support#support-faq',
                        uuid: null,
                        anchor: null,
                        target: null,
                        linktype: 'url',
                      },
                    },
                    { type: 'textStyle', attrs: { color: '#1565C0' } },
                    { type: 'underline' },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                {
                  text: 'Read our T\u0026Cs',
                  type: 'text',
                  marks: [
                    {
                      type: 'link',
                      attrs: {
                        href: 'https://www.cinch.co.uk/terms-and-conditions',
                        uuid: null,
                        anchor: null,
                        target: null,
                        linktype: 'url',
                      },
                    },
                    { type: 'textStyle', attrs: { color: '#1565C0' } },
                    { type: 'underline' },
                  ],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                {
                  text: '⠀',
                  type: 'text',
                  marks: [{ type: 'textStyle', attrs: { color: '#DF000F' } }],
                },
              ],
            },
            {
              type: 'paragraph',
              attrs: { textAlign: 'left' },
              content: [
                {
                  text: '⠀',
                  type: 'text',
                  marks: [{ type: 'textStyle', attrs: { color: '#DF000F' } }],
                },
              ],
            },
          ],
        },
        component: 'RichText',
        _editable:
          '\u003C!--#storyblok#{"name": "RichText", "space": "143588", "uid": "1e2f451a-4990-4d68-84fc-5a91b192334f", "id": "175748037529274"}--\u003E',
      },
    ],
    hero: [
      {
        _uid: 'dc381d65-a9a4-458d-927c-60840ecc7337',
        body: 'We’re sure you’ll love your new car but if you change your mind, we’ve got you, with a 14-day money back guarantee',
        image: {
          id: 175_757_907_075_348,
          alt: 'Car in a transparent background with a pound symbol indicating money back on returns',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/900x600/3713e0dbc2/returns.png',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Car in a transparent background with a pound symbol indicating money back on returns',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        title: 'Money back guarantee',
        component: 'GenericHero',
        _editable:
          '\u003C!--#storyblok#{"name": "GenericHero", "space": "143588", "uid": "dc381d65-a9a4-458d-927c-60840ecc7337", "id": "175748037529274"}--\u003E',
      },
    ],
    component: 'LandingPage',
    _editable:
      '\u003C!--#storyblok#{"name": "LandingPage", "space": "143588", "uid": "e11cd7e3-867b-4d31-b03d-c28f439c791b", "id": "175748037529274"}--\u003E',
  },
  slug: 'returns',
  full_slug: 'returns',
  sort_by_date: null,
  position: -300,
  tag_list: [],
  is_startpage: false,
  parent_id: 0,
  meta_data: null,
  group_id: '4037c170-e292-4260-b97b-b1917d788f4a',
  first_published_at: '2026-05-05T12:51:19.442Z',
  lang: 'default',
  alternates: [],
}
